<app-header #header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="iframe-container">
<iframe class="blog" src="https://www.cheapcharts.de/blog/" frameborder="0"></iframe>
</div>